import { Component } from '@angular/core';
import { AuthService } from '../../Services/auth.service';

@Component({
  selector: 'app-news-types-window',
  standalone: false,
  templateUrl: './news-types-window.component.html',
  styleUrl: './news-types-window.component.css'
})
export class NewsTypesWindowComponent {
  menuItems = [
    { path: "/newsProvider/co-tech", label: "menu.tech_collaborative" },
    { path: "/newsProvider/immobilier", label: "menu.real_estate" },
    { path: "/newsProvider/business-tech", label: "menu.business_tech" },
    { path: "/newsProvider/rssbourse", label: "menu.stock_market" },
    { path: "/newsProvider/patrimoine", label: "menu.heritage_wealth" },
    { path: "/newsProvider/economie-social", label: "menu.social_economy" },
    { path: "/newsProvider/finances-publiques", label: "menu.public_finances" },
    { path: "/newsProvider/international", label: "menu.international" },
    { path: "/newsProvider/entreprises", label: "menu.businesses" },
    { path: "/newsProvider/industries", label: "menu.industries" },
    { path: "/newsProvider/services", label: "menu.services" },
    { path: "/newsProvider/transports", label: "menu.transportation" },
    { path: "/newsProvider/assurance-banque", label: "menu.insurance_banking" },
    { path: "/newsProvider/aeronautique", label: "menu.aeronautics" },
    { path: "/newsProvider/energie", label: "menu.energy" },
    { path: "/newsProvider/culture-loisirs", label: "menu.culture_leisure" },
    { path: "/newsProvider/consommation", label: "menu.consumer_news" },
    { path: "/newsProvider/emploi", label: "menu.employment" },
    { path: "/newsProvider/vie-de-bureau", label: "menu.office_life" },
    { path: "/newsProvider/retraite", label: "menu.retirement" },
    { path: "/newsProvider/placements-epargne", label: "menu.savings_investments" },
    { path: "/newsProvider/impots-fiscalite", label: "menu.taxes_fiscal_policy" },
    { path: "/newsProvider/succession", label: "menu.inheritance_estate" },
    { path: "/newsProvider/economie", label: "menu.economy" },
    { path: "/newsProvider/crypto", label: "menu.cryptocurrency" },
    { path: "/newsProvider/experts", label: "menu.expert_opinions" },
    { path: "/newsProvider/actualite-medias", label: "menu.media_news" }
  ];

  userRole: string;

  constructor(private auth: AuthService) {
    this.userRole = this.auth.getRoles();
  }

  getIcon(path: string): string {
    const iconMap: { [key: string]: string } = {
      "/newsProvider/co-tech": "pi pi-globe",  
      "/newsProvider/immobilier": "pi pi-home",
      "/newsProvider/business-tech": "pi pi-briefcase",
      "/newsProvider/rssbourse": "pi pi-chart-line",
      "/newsProvider/patrimoine": "pi pi-star",
      "/newsProvider/economie-social": "pi pi-users",
      "/newsProvider/finances-publiques": "pi pi-wallet",
      "/newsProvider/international": "pi pi-globe",
      "/newsProvider/entreprises": "pi pi-building",
      "/newsProvider/industries": "pi pi-shop",
      "/newsProvider/services": "pi pi-cog",
      "/newsProvider/transports": "pi pi-truck",
      "/newsProvider/assurance-banque": "pi pi-credit-card",
      "/newsProvider/aeronautique": "pi pi-send",
      "/newsProvider/energie": "pi pi-bolt",
      "/newsProvider/culture-loisirs": "pi pi-sort-numeric-up-alt",
      "/newsProvider/consommation": "pi pi-shopping-cart",
      "/newsProvider/emploi": "pi pi-user",
      "/newsProvider/vie-de-bureau": "pi pi-desktop",
      "/newsProvider/retraite": "pi pi-hourglass",
      "/newsProvider/placements-epargne": "pi pi-dollar",
      "/newsProvider/impots-fiscalite": "pi pi-percentage",
      "/newsProvider/succession": "pi pi-inbox",
      "/newsProvider/economie": "pi pi-chart-bar",
      "/newsProvider/crypto": "pi pi-bitcoin",
      "/newsProvider/experts": "pi pi-comment",
      "/newsProvider/actualite-medias": "pi pi-book"
    };

    return iconMap[path] || "pi pi-circle"; // Default icon if not found
  }
}
